<template>
  <v-app :class="{ 'filters-loading': filtersStore.isLoading }">
    <ChipsFilters />
    <CityFilters />
    <DateFilters />
    <PlaceFilters />
    <PriceFilters />
    <ExperienceFilters />
    <GenderFilters />
    <CategoryFilters />
    <ScienceFilters />
    <PatientAgeFilters />
    <HighRatingFilters />
    <OtherSpecialityFilters />
    <DiseaseFilters />
    <ClubSwitchFilters />
    <VisitLocationFilters />
    <AppointmentFilters />
    <DoctorFilters />
  </v-app>
</template>

<script setup lang="ts">
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import getValidFilters from 'www/vue_components/common/TheFilters/doctors/functions/getValidFilters'
import ChipsFilters from 'www/vue_components/common/TheFilters/doctors/components/ChipsFilters/ChipsFilters.vue'
import CityFilters from 'www/vue_components/common/TheFilters/doctors/components/CityFilters/CityFilters.vue'
import DateFilters from 'www/vue_components/common/TheFilters/doctors/components/DateFilters/DateFilters.vue'
import PlaceFilters from 'www/vue_components/common/TheFilters/doctors/components/PlaceFilters/PlaceFilters.vue'
import PriceFilters from 'www/vue_components/common/TheFilters/doctors/components/PriceFilters/PriceFilters.vue'
import DoctorFilters from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/DoctorFilters.vue'
import GenderFilters from 'www/vue_components/common/TheFilters/doctors/components/GenderFilters/GenderFilters.vue'
import ScienceFilters from 'www/vue_components/common/TheFilters/doctors/components/ScienceFilters/ScienceFilters.vue'
import CategoryFilters from 'www/vue_components/common/TheFilters/doctors/components/CategoryFilters/CategoryFilters.vue'
import ExperienceFilters from 'www/vue_components/common/TheFilters/doctors/components/ExperienceFilters/ExperienceFilters.vue'
import PatientAgeFilters from 'www/vue_components/common/TheFilters/doctors/components/PatientAgeFilters/PatientAgeFilters.vue'
import HighRatingFilters from 'www/vue_components/common/TheFilters/doctors/components/HighRatingFilters/HighRatingFilters.vue'
import ClubSwitchFilters from 'www/vue_components/common/TheFilters/doctors/components/ClubSwitchFilters/ClubSwitchFilters.vue'
import VisitLocationFilters from 'www/vue_components/common/TheFilters/doctors/components/VisitLocationFilters/VisitLocationFilters.vue'
import AppointmentFilters from 'www/vue_components/common/TheFilters/doctors/components/AppointmentFilters/AppointmentFilters.vue'
import OtherSpecialityFilters from 'www/vue_components/common/TheFilters/doctors/components/OtherSpecialityFilters/OtherSpecialityFilters.vue'
import DiseaseFilters from 'www/vue_components/common/TheFilters/doctors/components/DiseaseFilters/DiseaseFilters.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'
import type {
  Url, Town, DomNodes, DoctorList,
} from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore.types'

const props = defineProps<{
  initCommonStore: {
    url: Url
    town: Town
    domNodes: DomNodes
    doctorList: DoctorList
  }
  initFiltersStore: Filters
}>()

const commonStore = useCommonStore()
const filtersStore = useFiltersStore()

commonStore.updateUrl(props.initCommonStore.url)
commonStore.updateTown(props.initCommonStore.town)
commonStore.updateDomNodes(props.initCommonStore.domNodes)
commonStore.updateDoctorList(props.initCommonStore.doctorList)

filtersStore.updateFilters(getValidFilters(props.initFiltersStore))
</script>

<style lang="scss" scoped>
.filters-loading {
  opacity: .5;
  pointer-events: none;
}
</style>
